var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbsenOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#0079D2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2944_1236",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2944_1236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 18.667C6.96667 18.667 6.65267 18.5365 6.39133 18.2757C6.13044 18.0143 6 17.7003 6 17.3337V9.33366C6 8.96699 6.13044 8.65321 6.39133 8.39233C6.65267 8.13099 6.96667 8.00033 7.33333 8.00033H8V4.66699H16V8.00033H16.6667C17.0333 8.00033 17.3473 8.13099 17.6087 8.39233C17.8696 8.65321 18 8.96699 18 9.33366V17.3337C18 17.7003 17.8696 18.0143 17.6087 18.2757C17.3473 18.5365 17.0333 18.667 16.6667 18.667H7.33333ZM9.33333 8.00033H14.6667V6.00033H9.33333V8.00033ZM7.33333 17.3337H16.6667V9.33366H7.33333V17.3337ZM12 16.667C11.0778 16.667 10.2918 16.3421 9.642 15.6923C8.99178 15.0421 8.66667 14.2559 8.66667 13.3337C8.66667 12.4114 8.99178 11.6252 9.642 10.975C10.2918 10.3252 11.0778 10.0003 12 10.0003C12.9222 10.0003 13.7084 10.3252 14.3587 10.975C15.0084 11.6252 15.3333 12.4114 15.3333 13.3337C15.3333 14.2559 15.0084 15.0421 14.3587 15.6923C13.7084 16.3421 12.9222 16.667 12 16.667ZM12 15.667C12.6444 15.667 13.1944 15.4392 13.65 14.9837C14.1056 14.5281 14.3333 13.9781 14.3333 13.3337C14.3333 12.6892 14.1056 12.1392 13.65 11.6837C13.1944 11.2281 12.6444 11.0003 12 11.0003C11.3556 11.0003 10.8056 11.2281 10.35 11.6837C9.89444 12.1392 9.66667 12.6892 9.66667 13.3337C9.66667 13.9781 9.89444 14.5281 10.35 14.9837C10.8056 15.4392 11.3556 15.667 12 15.667ZM12.7667 14.567L11.6667 13.467V11.667H12.3333V13.2003L13.2333 14.1003L12.7667 14.567Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbsenOut);
export default __webpack_public_path__ + "static/media/absen_out.77b4e595df17d9ed083d532261733ccd.svg";
export { ForwardRef as ReactComponent };